/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { API_URL, APIV, TENANT, IS_REQEST_RESPONSE_ENCRYPT, IGNORE_END_POINT_ENCRYPTION, TENANTS } from './../config/constant';
import secureStorage from './../config/encrypt';
import { toast } from 'react-toastify';
import ls from "local-storage";
import CryptoJS from 'crypto-js';
import forge from 'node-forge';
const Axios = axios.create();
//export const TENANT = ls.get("tenant") || TENANTS.OTO;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

Axios.interceptors.response.use(
    (response) => {
        if (response.data && response.data.status !== 200) {
            console.error(`${response.data.status} - ${response.data.message}`, response.data);
        }
        ls.set("is_redirect", 1);
        return response;
    },
    async (error) => {
        console.error(`${error.response.status} - ${error.response.statusText}`, error.response);

        // Original request configuration.
        const originalRequest = error?.config;

        if (originalRequest.url === `${API_URL.GETWAY_API}sfa/user/refresh_token`) {
            // This is a failed refresh token request. Logout user.
            window.location.href = '/logout';
            return Promise.reject(error);
        }

        // Check if the error response exists and has a status of 401 (Unauthorized).
        if (error.response && error.response.status === 401) {

            // If a token refresh is already in process.
            if (isRefreshing) {
                // Create a new promise and push it into the failedQueue along with the original request.
                // We use the original request to later retry this failed request.
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject, originalRequest });
                })
                    .then((token) => {
                        // Once the token is refreshed, update the Authorization header.
                        originalRequest.headers["Authorization"] = token;
                        // Retry the original request.
                        return Axios(originalRequest);
                    })
                    .catch((err) => {
                        // If token refresh fails, reject the promise.
                        return Promise.reject(err);
                    });
            }

            // Flag to indicate that this request has been retried.
            originalRequest._retry = true;

            // Flag to indicate a token refresh is in progress.
            isRefreshing = true;

            // Retrieve the redirect status.
            let is_redirect = ls.get("is_redirect");

            // Object to store the new refresh token.
            let refresh_token_data = {};

            // If a redirect is not in progress, execute this block.
            if (is_redirect !== 0) {
                try {
                    // Attempt to refresh the token.
                    refresh_token_data = await refreshToken();

                    // Process the queue of failed requests.
                    processQueue(null, refresh_token_data.token);

                    // Update the Authorization header with the new token.
                    originalRequest.headers["Authorization"] = refresh_token_data.token;

                    // Retry the original request with the new token.
                    return Axios(originalRequest);

                } catch (err) {
                    // If token refresh fails, clear the queue and redirect to logout.
                    processQueue(err, null);
                    window.location.href = "/logout";
                    return Promise.reject(err);
                } finally {
                    // Reset the flag to indicate that the token refresh has completed.
                    isRefreshing = false;
                }
            }
        }
        // If the status code is not 401, return the error response as is.
        return error.response;
    }

);


window.commonErrorToast = function (error) {
    if (typeof error == "string") toast.error(error);
    else if (error.message) toast.error("Helllo", error.message);
}

async function refreshToken() {
    try {
        let loginUserInfo = (secureStorage.getItem('loginUserInfo'))
            ? secureStorage.getItem('loginUserInfo')
            : null;
        if (loginUserInfo) {
            const { data } = await Axios.post(`${API_URL.GETWAY_API}sfa/user/refresh_token`, { refresh_token: loginUserInfo.refresh_token }, {
                headers: { 'Authorization': loginUserInfo.token, 'tenant': getEntitySource() }
            });
            if (data && data.status === 200) {
                ls.set('logged_data', data.data);
                window.sessionStorage.setItem('login_logged_data', data.data)
                ls.set('is_redirect', 0)
                secureStorage.setItem('loginUserInfo', data.data);
                return data.data;
            } else {
                window.location.href = '/logout';
            }
        } else {
            window.location.href = '/logout';
        }

    } catch (error) {
        console.error("Error refreshing token: ", error);
        window.location.href = '/logout';
        return null;
    }
}

function getEntitySource() {
    let login_tenant = window.sessionStorage.getItem("login_tenant")
    let selected_tenant = TENANT
    if (login_tenant && login_tenant !== selected_tenant) {
        window.sessionStorage.setItem("login_tenant", selected_tenant)
        window.sessionStorage.setItem("login_logged_data", ls.get("logged_data"))
        window.sessionStorage.setItem("login_email", ls.get("login_email"))
        window.location.href = "/user-management";
    }
    return TENANT
}
const hybridEncrypt = (data, public_key) => {
    try {
        const symmetricKey = CryptoJS.lib.WordArray.random(32);
        const iv = CryptoJS.lib.WordArray.random(16);

        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            symmetricKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        ).toString();

        const publicKey = forge.pki.publicKeyFromPem(public_key);
        const symmetricKeyBytes = forge.util.hexToBytes(symmetricKey.toString(CryptoJS.enc.Hex));
        const encryptedSymmetricKey = forge.util.encode64(
            publicKey.encrypt(symmetricKeyBytes, 'RSA-OAEP')
        );

        return {
            encrypted_data: encryptedData,
            encrypted_symmetric_key: encryptedSymmetricKey,
            iv: iv.toString(CryptoJS.enc.Base64)
        };
    } catch (error) {
        console.error("Encryption failed: ", error);
        throw new Error("Failed to encrypt response");
    }
}

const hybridDecrypt = (encrypted_data, encrypted_symmetric_key, iv) => {
    const response_key = CryptoJS.enc.Utf8.parse(REQUEST_RESPONSE_ENCRYPTION.response_aes_key);
    const zero_iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0]); // 16 bytes of zeros

    const decrypted_symmetric_key_base64 = CryptoJS.AES.decrypt(
        encrypted_symmetric_key,
        response_key,
        {
            iv: zero_iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    ).toString(CryptoJS.enc.Utf8);

    const symmetric_key = CryptoJS.enc.Base64.parse(decrypted_symmetric_key_base64);
    const iv_wordarray = CryptoJS.enc.Base64.parse(iv);

    const decrypted_data = CryptoJS.AES.decrypt(
        encrypted_data,
        symmetric_key,
        {
            iv: iv_wordarray,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    ).toString(CryptoJS.enc.Utf8);

    return JSON.parse(decrypted_data);
};

let PUBLIC_KEY_NODE = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDG2koJfj4vF4UkiSl9vnmznE31\nMV7wslypRbwHEbN0KL4YtpH42euTfTEpD3RuyC3+QG4jHAmtyn+jxQJsZN8/Tq4L\n4N+tp83PZDQoazJDBVDtBCx5Rsyz9P0xemJkbfhbY4LRwQojDYLBlNRI4LHuBnnf\n1sL3PU9daSNQud+GBQIDAQAB\n-----END PUBLIC KEY-----\n";
let PUBLIC_KEY_PH = "-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA+TLcx6yGxf2SRnhK3ooT\nnY4hZbf5Jos2LXrzIwlubfmxZGURsxYRR2NQYco8nnxJM8sUYiFGcPi2t2s04Z8b\nXy1k2JzNaw1pKNo0xg0r42IzluHLhqIHDBwcX4X492BhoGW+crSH0SNWUushY2k7\nxupYa8wC51XhxBfVkhsrEsEd8VJTqPhlKlVhImPQ6kZFzQM/bxvyIkkAeonqK4Ni\nnPIfxYuYkA/NlpRVhQHkYPKrBSl31kIAldZI9R59T44EsXnq/QPCr4Euw6qa4NNe\nhcDClJLSvg34Qs9/M8jL1s9Wy1Sg07HnjTdn5fAcTcskSIPyZG09+UpA5+Pa1yMD\nUwIDAQAB\n-----END PUBLIC KEY-----";

export const REQUEST_RESPONSE_ENCRYPTION = {
    aes_algo: "aes-256-cbc",
    response_aes_key: "770A8A65DA156D24EE2A093277530142",
    public_key: TENANT === TENANTS.PH ? PUBLIC_KEY_PH : PUBLIC_KEY_NODE
};
export default {
    getMasters(list) {
        return this.get("/core/commonservice/master", { master: list });
    },
    getToken() {
        let fetchHeader = (secureStorage.getItem('loginUserInfo'))
            ? secureStorage.getItem('loginUserInfo')
            : {};
        // console.log('$$$$$$$$$$$$$$',fetchHeader.token);
        return (fetchHeader && fetchHeader.token)
            ? fetchHeader.token : null;
    },
    delete(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['tenant'] = getEntitySource()
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.delete(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    post(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['tenant'] = getEntitySource()
        //headers['apikey'] = API_URL.API_KEY;                 
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        let routeArray = URL?.split('/') || [];
        let responsePromise;
        let endPoint = routeArray[routeArray.length - 1];       
        if (IS_REQEST_RESPONSE_ENCRYPT === 1 && !IGNORE_END_POINT_ENCRYPTION.includes(endPoint)) {           
            //headers["is_encrypt_response"] = headers.is_encrypt_response ?? 1;          
            if (body) {
                body = hybridEncrypt(body, REQUEST_RESPONSE_ENCRYPTION.public_key)
            }
        }
        responsePromise = Axios.post(`${API_URL.GETWAY_API}${URL}`, body, { headers, withCredentials: false })
        return new Promise((resolve, reject) => {
            responsePromise.then((response) => {
                if (response.data.encrypted_symmetric_key) {
                    let { encrypted_data, encrypted_symmetric_key, iv } = response.data;
                    let decryptedResponse = hybridDecrypt(encrypted_data, encrypted_symmetric_key, iv);
                    response.data = decryptedResponse
                }
                resolve(response);
            }).catch(error => reject(error))
        })
    },
    put(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['tenant'] = getEntitySource()
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.put(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    get(URL, query, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['tenant'] = getEntitySource()
        //headers['apikey'] = API_URL.API_KEY;
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.get(`${API_URL.GETWAY_API}${URL}`,
            { params: query, headers })
    },
    uploadFilesToS3(postdata, headers) {
        headers = headers || {};
        headers['tenant'] = getEntitySource()
        return axios.post(
            //`https://stage-api.oto.com/core/commonservice/docs_upload`,
            `${API_URL.GETWAY_API}core/commonservice/docs_upload`,
            postdata,
            { headers }
        );
    },
    download(URL, body, responseType, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['tenant'] = getEntitySource()
        //headers['apikey'] = API_URL.API_KEY;        
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.post(`${API_URL.GETWAY_API}${URL}`, body, { responseType, headers, withCredentials: false })
    },
}